<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.profile.applyCard.default" :canGoBack="true"></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy" rounded>
            <div class>
                <div
                    class="text-primary text-base text-center font-semibold"
                >{{ lbl.profile.applyCard.selectBank }}</div>
                <div class="px-8 text-center text-sm text-black-1 mt-2" v-html="textTitle"></div>
                <BankList @onLoading="onLoading" @onLoaded="onLoaded" @onError="onError"></BankList>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />

        <div class="flyout-zone">
            <ModalMaster :controller="modalController"></ModalMaster>
        </div>
    </div>
</template>
<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import BankList from "../component/BankList.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"
import PdpaMixin from "@/mixin/PdpaMixin";
import BzbsBlob  from '../../../core/Blob/BzbsBlob'
import Locale from "@/helper/locale/Locale.js";
// mixins
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

export default {
    name: 'ApplyCreditCardPage',
    props: {},
    components: {
    TopBarBg,
    PageContent,
    Footer,
    BankList,
    ModalMaster
},
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    emits: [],
    data: function () {
        return {
            hasPoweredBy: false,
            banks: [],
            textTitle: '',
        }
    },
    created: function () {
        console.log('ApplyCreditCardPage created')
        this.getBlobConfig();
    },
    methods: {
        onLoading: function () {
            this.loadingModal.show()
        },
        onLoaded: function () {
            this.loadingModal.hide()
        },
        onError: function (err) {
            this.errorApi(err)
        },
        onClickBack: function(){

        },
        getBlobConfig: function () {
            let localeCode = Locale.getLocaleCode();
            // https://devstoragebuzzebees.blob.core.windows.net/webconfig/jcb/applycard-text.json
            let path = "/webconfig/jcb/applycard-text.json";
            return new Promise((resolve) => {
                BzbsBlob.apiGetBlobConfig(path).subscribe({
                    next: (data) => {
                        console.log('getBlobConfig', data[1033].text)
                        this.textTitle = data[localeCode].text;
                        resolve(data);
                    },
                    error: (err) => {
                        resolve();
                        this.errorApi(err, true, {
                            title: this.lbl.default.error,
                        });
                    },
                });
            });
        },
    }
}
</script>
